import { render, staticRenderFns } from "./ProfessionalProjectMeeting.vue?vue&type=template&id=5ae4603c&scoped=true"
import script from "./ProfessionalProjectMeeting.vue?vue&type=script&lang=js"
export * from "./ProfessionalProjectMeeting.vue?vue&type=script&lang=js"
import style0 from "./ProfessionalProjectMeeting.vue?vue&type=style&index=0&id=5ae4603c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae4603c",
  null
  
)

export default component.exports